module.exports = __webpack_public_path__ + "media/images/tour/d/id-4f323f71923cd772e56bcfca4187dbf7.png";